import { useState, useEffect, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Navigation from './pages/home/components/Navigation';
import Footer from './components/feature/Footer';
import { AuthProvider } from './context/AuthContext';
import { CustomerProvider } from './context/CustomerContext';
import { StoreProvider } from './context/StoreContext';
import { CartProvider } from './context/CartContext';
import { OrderProvider } from './context/OrderContext';
import { ToastProvider } from './context/ToastContext';
import { WishlistProvider } from './context/WishlistContext';
import { NotificationProvider } from './context/NotificationContext';
import { LoyaltyProvider } from './context/LoyaltyContext';
import { TrackOrderButton } from './components/TrackOrderButton';
import LocationGuard from './components/LocationGuard';
import Preloader from './components/Preloader';
import ScrollToTop from './components/ScrollToTop';

function AppContent() {
    return (
        <>
            <Navigation />
            <ScrollToTop />
            <LocationGuard>
                <Suspense fallback={<div className="min-h-screen bg-obsidian" />}>
                    <AppRoutes />
                </Suspense>
            </LocationGuard>
            <TrackOrderButton />
            <Footer />
        </>
    );
}

function App() {
    const [isAssetsLoaded, setIsAssetsLoaded] = useState(false);

    // Check if we've already loaded assets in this session to skip preloader on internal re-mounts
    useEffect(() => {
        const loaded = sessionStorage.getItem('tcr_assets_loaded');
        if (loaded) setIsAssetsLoaded(true);
    }, []);

    const handleDone = () => {
        setIsAssetsLoaded(true);
        sessionStorage.setItem('tcr_assets_loaded', 'true');
    };

    if (!isAssetsLoaded) {
        return <Preloader onDone={handleDone} />;
    }

    return (
        <BrowserRouter basename={__BASE_PATH__}>
            <ToastProvider>
                <AuthProvider>
                    <CustomerProvider>
                        <LoyaltyProvider>
                            <StoreProvider>
                                <CartProvider>
                                    <OrderProvider>
                                        <WishlistProvider>
                                            <NotificationProvider>
                                                <AppContent />
                                            </NotificationProvider>
                                        </WishlistProvider>
                                    </OrderProvider>
                                </CartProvider>
                            </StoreProvider>
                        </LoyaltyProvider>
                    </CustomerProvider>
                </AuthProvider>
            </ToastProvider>
        </BrowserRouter>
    );
}

export default App;
